import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback used when the CMS hasn't been touched yet — the original
// company logo that shipped with this build.
export const DEFAULT_LOGO_URL = "https://customer-assets.emergentagent.com/job_15cab680-befd-4974-8675-ac0323fde202/artifacts/nhiz70qf_North%20Somerset%20Enviroment%20-%20Logo.png";

// Resolve an /api/uploaded-images/{id} path against REACT_APP_BACKEND_URL.
// External URLs are returned as-is.
export const resolveAssetUrl = (url) => {
  if (!url) return DEFAULT_LOGO_URL;
  return url.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
};

// Tiny hook: returns the current header logo URL (already resolved to an
// absolute URL). Falls back to DEFAULT_LOGO_URL when the CMS document is
// missing or the field is empty. Refreshes whenever a same-tab event
// `site-logo-updated` is dispatched (used by the admin panel to push the
// new logo into the header without a full reload).
export function useSiteLogo() {
  const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO_URL);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/page-content/site_settings`);
      const url = r.data?.header_logo_url;
      if (url) setLogoUrl(resolveAssetUrl(url));
      else setLogoUrl(DEFAULT_LOGO_URL);
    } catch {
      setLogoUrl(DEFAULT_LOGO_URL);
    }
  };

  useEffect(() => {
    load();
    const onUpdate = () => load();
    window.addEventListener('site-logo-updated', onUpdate);
    return () => window.removeEventListener('site-logo-updated', onUpdate);
  }, []);

  return logoUrl;
}
